import React, { useState, useContext, useEffect } from 'react'
import { Button, FloatingLabel, Form } from 'react-bootstrap'
import { NavLink, useNavigate } from 'react-router-dom'
import Loader from '../loader/Loader'
import { VscEye, VscEyeClosed } from "react-icons/vsc"
import { EyeIcon, LockIcon } from '../../constants/svgs'
import { FIELD, VALIDATIONS, VALIDATIONS_TEXT } from '../../constants/app-constants'
import { ToastContainer } from 'react-toastify'
import { UserData, UserRole } from '../../App'
import { Controller, useForm } from 'react-hook-form'
import CustomInput from '../forms/CustomInput'
import Assets from '../../constants/images'
import { error, success } from '../../constants/msg'
import { ForgetPassword } from '../../services/auth/auth'

const ForgotPasswordForm = () => {
    const navigate = useNavigate()
    const [isDisabled, setIsDisabled] = useState(false)
    const [showPassword, setShowPassword] = useState(false)
    const [userData, setUserData] = useContext(UserData)
    const [userRole, setUserRole] = useContext(UserRole)

    const { register, handleSubmit, watch, control, formState: { errors } } = useForm({
        mode: "onChange"
    });

    const onSubmit = async (data) => {
        setIsDisabled(true)
        try {
            const res = await ForgetPassword({ email: data.email })
            success(res.data.message)
            setIsDisabled(false)
            setTimeout(() => {
                navigate("/verify-otp", { state: { email: data.email } })
            }, 1500);

        }
        catch (e) {
            setIsDisabled(false)
            error(e.response.data.message)
        }
    }

    return (
        <div className='auth-card forgot-password-form'>
            <ToastContainer />

            <div className="logo-wrapper mb-30 d-block d-xl-none">
                <img src={Assets.Logo} alt="" />
            </div>

            <div className='header'>
                <NavLink className="text-grey d-block mb-2 w-400" to="/signin">Back</NavLink>
                <h1>Forgot Password</h1>
                <p className='mt-2'>Enter your registered email address. We will send you a verfication code.</p>
            </div>

            <Form onSubmit={handleSubmit(onSubmit)}>
                <div className='mt-30'>
                    {/* EMAIL INPUT */}
                    <div>
                        <Controller
                            control={control}
                            name={FIELD.email}
                            rules={{
                                required: {
                                    value: true,
                                    message: VALIDATIONS_TEXT.EMAIL_REQUIRED,
                                },
                                maxLength: {
                                    value: VALIDATIONS.EMAIL,
                                    message: VALIDATIONS_TEXT.EMAIL_MAX
                                },
                                pattern: {
                                    value: /\S+@\S+\.\S+/,
                                    message: VALIDATIONS_TEXT.EMAIL_FORMAT
                                }
                            }}
                            render={({ field }) => (
                                <CustomInput
                                    {...field}
                                    isDisabled={false}
                                    controlId={FIELD.email}
                                    name={FIELD.email}
                                    placeholder="Email *"
                                    type="email"
                                    label="Email *"
                                    styles=""
                                />
                            )}
                        />
                        {errors[FIELD.email] && <small className='text-start d-block text-danger mt-1'>{errors[FIELD.email].message}</small>}
                    </div>

                    <Button type="submit" className='w-100 btn-solid mt-40'>
                        {
                            isDisabled ? <Loader /> : "Submit"
                        }
                    </Button>

                    <div className="footer border-top pt-30 mt-30">
                        <p className='w-300'>
                            Protected by recaptcha and subject to the WTT
                            <NavLink to="/privacy-policy"> Privacy Policy </NavLink>
                            and <NavLink to="/terms-and-conditions"> Terms of Service</NavLink>.
                        </p>
                    </div>
                </div>
            </Form>
        </div>
    )
}

export default ForgotPasswordForm